module.exports = __webpack_public_path__ + "static/media/g10.5a69c423.jpeg";